import { render, staticRenderFns } from "./PlayTab.vue?vue&type=template&id=9b4deb5a&scoped=true"
import script from "./PlayTab.vue?vue&type=script&lang=js"
export * from "./PlayTab.vue?vue&type=script&lang=js"
import style0 from "./PlayTab.vue?vue&type=style&index=0&id=9b4deb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4deb5a",
  null
  
)

export default component.exports